import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

const rules = {
    currentPolicyExpirationDate: 'required',
    effectiveDate: 'required',
    receiveDocumentsElectronically: 'required'
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};